import holiday from "./holiday.component";
import holidayUrls from "./holiday.urls";
import HolidayTransforms from "./holiday.transforms";

const holidayModule = angular
  .module("app.components.holiday", [])
  .component("holidayPage", holiday)
  .service("HolidayTransforms", HolidayTransforms)
  .config(holidayUrls);

export default holidayModule;



// WEBPACK FOOTER //
// ./src/pages/holiday/holiday.module.js